import { gql, TypedDocumentNode } from '@apollo/client';

import {
  FavoritesList,
  FavoritesListCreateInput,
  FavoritesListDeleteInput,
  FavoritesListsTreeConnectionInput,
  FavoritesListTreeConnection,
  FavoritesListUpdateInput,
} from '@atom/types/favorite';

export const BASE_FAVORITE_LIST_FRAGMENT = gql`
  fragment BaseFavoritesList on FavoritesList {
    id
    name
    subjectType
    favorites {
      id
      subjectId
      subjectType
      subjectName
      listIds
      data {
        colorId
        assetType
        categories {
          id
          name
        }
        photoUrl
        email
        firstName
        lastName
        markerId
        locationType
        schemaId
        isMaterial
        inactive
      }
      createdDate
      createdBy {
        firstName
        lastName
      }
    }
    createdDate
    createdBy {
      firstName
      lastName
    }
  }
`;

export const GET_FAVORITES_LIST_TREE: TypedDocumentNode<
  { favoritesListTree: FavoritesListTreeConnection },
  { input: FavoritesListsTreeConnectionInput }
> = gql`
  query favoritesListTree($input: FavoritesListsTreeConnectionInput!) {
    favoritesListTree(input: $input) {
      totalCount
      totalUniqueFavorites
      favoritesLists {
        ...BaseFavoritesList
      }
    }
  }
  ${BASE_FAVORITE_LIST_FRAGMENT}
`;

export const CREATE_FAVORITES_LIST: TypedDocumentNode<
  { favoritesListCreate: FavoritesList },
  { input: FavoritesListCreateInput }
> = gql`
  mutation favoritesListCreate($input: FavoritesListCreateInput!) {
    favoritesListCreate(input: $input) {
      ...BaseFavoritesList
    }
  }
  ${BASE_FAVORITE_LIST_FRAGMENT}
`;

export const DELETE_FAVORITES_LIST: TypedDocumentNode<
  { favoritesListDelete: boolean },
  { input: FavoritesListDeleteInput }
> = gql`
  mutation favoritesListDelete($input: FavoritesListDeleteInput!) {
    favoritesListDelete(input: $input)
  }
`;

export const UPDATE_FAVORITES_LIST: TypedDocumentNode<
  { favoritesListUpdate: FavoritesList },
  { input: FavoritesListUpdateInput }
> = gql`
  mutation favoritesListUpdate($input: FavoritesListUpdateInput!) {
    favoritesListUpdate(input: $input) {
      ...BaseFavoritesList
    }
  }
  ${BASE_FAVORITE_LIST_FRAGMENT}
`;
